import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

export class ErrorBoundaryXcala extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    /* logErrorToMyService(error, errorInfo); */
    // biome-ignore lint/nursery/noConsole: <explanation>
    console.log({ error, errorInfo });
  }
  render() {
    const {
      minHeight,
      padding = 4,
      fontSizeTop = '14px',
      fontSizeBottom = '14px',
      imageWidth = '40px',
      imageHeight = '40px',
      responsiveMobile = false,
      onlyImage = false,
    } = this.props;

    if (this.state.hasError) {
      return (
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='space-around'
          width='100%'
          height='100%'
          minHeight={minHeight}
          flex='1'
          borderRadius='6px'
          bgcolor={onlyImage ? 'transparent' : '#fff'}
          p={padding}
          textAlign='center'
          overflow='hidden'>
          {!onlyImage && (
            <Typography variant='h6' sx={{ fontSize: fontSizeTop }}>
              ¡Pronto estará disponible!
            </Typography>
          )}

          <Stack width={imageWidth} height={imageHeight} my={1}>
            <img
              alt='Error'
              src='/assets/images/maintenancetriangle.svg'
              style={{
                width: '100%',
                height: '100%',
                display: 'inline-block',
              }}
            />
          </Stack>

          {!onlyImage && (
            <Typography
              variant='h6'
              sx={{
                fontSize: fontSizeBottom,
                whiteSpace: 'pre-line',
              }}>
              Este espacio se encuentra{'\n'}en mantenimiento.
            </Typography>
          )}
        </Box>
      );
    }
    // Si no hay hijos, renderiza algo por defecto o null
    return this.props.children || null;
  }
}
